import React, { Component } from 'react';
import {
  Container, Row, Col, Table, Button,
} from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import qs from 'query-string';
import axios from 'axios';
import { CSVReader } from 'react-papaparse';
import Client from './widgets/Client';

const buttonRef = React.createRef();

class Home extends Component {
  state = {
    clients: '',
    loadmore: true,
    totalcount: 0,
    count: 0,
    recruiterOptions: [],
  };

  componentDidMount() {
    this.setState({ loadmore: true }, async () => {
      try {
        const recruiterOptions = [];
        const clients = await this.getClients(
          5,
          0,
          'desc',
          '',
          qs.parse(this.props.location.search).search,
        );
        const resp = await axios.get('/api/getRecruiters', {headers:{ Authorization: localStorage.getItem('token') } });
        let name;
        resp.data.map((recruiter) => {
          name = recruiter.name;
          recruiterOptions.push({
            name,
            id: recruiter._id,
          });
        });
        this.setState({ clients, loadmore: false, recruiterOptions });
      } catch (error) {
        console.error(error);
      }
    });
  }

  getClients = (limit = 5, skip = 0, order = 'asc', list = '', search = '') => axios
    .get(
      `/api/getClients?limit=${limit}&skip=${skip}&order=${order}&search=${search}&user=${this.props.user.employer
      }`, {headers:{ Authorization: localStorage.getItem('token') } }
    )
    .then((response) => {
      // i am returning the total count so i hae to filter out the number in the array to gie a alid object data
      const searchObject = [];
      if (list) {
        response.data.filter((item) => {
          if (typeof item === 'object') {
            searchObject.push(item);
          }
        });
        this.setState({ count: list.length + searchObject.length });
        return [...list, ...searchObject];
      }

      response.data.filter((item) => {
        if (typeof item === 'object') {
          searchObject.push(item);
        }
      });
      this.setState({
        totalcount: response.data[response.data.length - 1],
        count: searchObject.length,
      });
      return searchObject;
    })
    .catch((err) => { });

  renderClients = clients => (clients
    ? clients.map((item, i) => (
      <Client
        detailsPage={() => this.props.history.push(`/clientdetails/${item._id}`, { client: item })}
        {...item}
        loading={this.state.loadmore}
        recruiterOptions={this.state.recruiterOptions}
        updateOption={this.updateOption}
        updateRecruiter={this.updateRecruiter}
        no={i + 1}
        key={item._id}
        loancount={item.loaninfo.length}
      />
    ))
    : null);

  updateRecruiter = (id, option) => {
    if (window.confirm('are you sure')) {
      if (option) {
        this.setState({ loadmore: true });
        axios
          .post(`/api/updaterecruiter/${id}/${option}`,{}, {headers:{ Authorization: localStorage.getItem('token') } })
          .then((response) => {
            this.setState({ loadmore: false });
          })
          .catch((err) => {
            this.setState({ loadmore: false });
            alert('an error occured');
          });
      }
    }
  };

  updateOption = (id, option) => {
    if (window.confirm('are you sure')) {
      if (option) {
        this.setState({ loadmore: true });
        axios
          .post(`/api/updateoption/${id}/${option}`,{}, {headers:{ Authorization: localStorage.getItem('token') } })
          .then((response) => {
            this.setState({ loadmore: false });
          })
          .catch((err) => {
            this.setState({ loadmore: false });
            alert('an error occured');
          });
      }
    }
  };

  getEligibilitys = async () => {
    const data = await axios.get('/api/getEligibilitys', {headers:{ Authorization: localStorage.getItem('token') } });
    this.setState({ csvData: data.data });
    // console.log(this.state.csvData);
  };

  loadmore = () => {
    this.setState({ loadmore: true }, async () => {
      try {
        const count = this.state.clients.length;
        const clients = await this.getClients(
          count + 5,
          count,
          'desc',
          this.state.clients,
          qs.parse(this.props.location.search).search,
        );

        this.setState({ clients, loadmore: false });
      } catch (error) {
        console.error(error);
      }
    });
  };

  handleOpenDialog = (e) => {
    // Note that the ref is set async, so it might be null at some point
    if (buttonRef.current) {
      buttonRef.current.removeFile(e);
      buttonRef.current.open(e);
    }
  }

  handleOnFileLoad = async (data) => {
    try {
      // console.log('---------------------------');
      const upload = data.filter(datum => datum.data['CLIENT ID'] && datum.data['PHONE NUMBER'] && datum.data.BRANCH && datum.data['BANK CODE'] && datum.data['ACCOUNT NUMBER'] && datum.data['RECRUITER ID']).map(datum => datum.data);
      // console.log(upload);
      await axios.post('/api/importclient', { imports: upload }, {headers:{ Authorization: localStorage.getItem('token') } });
      alert('Sheet is processing, check back in 30minutes');
      // window.location.reload();
    //  console.log('---------------------------');
    } catch (error) {
      console.log(error);
      alert('An error occured');
    }
  }

  handleOnError = (err, file, inputElem, reason) => {
    console.log(err);
  }

  handleOnRemoveFile = (data) => {
    // console.log('---------------------------');
    // console.log(data);
    // console.log('---------------------------');
  }

  handleRemoveFile = (e) => {
    // Note that the ref is set async, so it might be null at some point
    if (buttonRef.current) {
      buttonRef.current.removeFile(e);
    }
  }

  render() {
    return (
      <Container>
        <Row>
       <label
         className="btn btnprimary btn-sm"
       >
         <CSVReader
           style={{ display: 'inline-block' }}
           config={{ header: true }}
           ref={buttonRef}
           onFileLoad={this.handleOnFileLoad}
           onError={this.handleOnError}
           noClick
           noDrag
          // addRemoveButton
           onRemoveFile={this.handleOnRemoveFile}
         >
           {({ file }) => (
                                            <span
                                                // className={`btn btn-indigo btn-sm`}
                                              onClick={this.handleOpenDialog}
                                            >
                                              {file ? file.name : 'Import Loandisk Client'}
                                            </span>
           )}
         </CSVReader>
       </label>
        </Row>
        <Row>
          <Col className="my-3" md={12}>
            <h2 className="text-center">Clients</h2>
            {' '}
            <h6 className="text-center">
              (
              {`${this.state.count} of ${this.state.totalcount}`}
)
            </h6>
          </Col>

          <Col md={12}>
            <Table striped hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Employer</th>
                  {/* <th>Repayment Method</th> */}
                  <th>Loans</th>
                  <th />
                  <th />
                </tr>
              </thead>
              <tbody>{this.renderClients(this.state.clients)}</tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col md={3} className="mx-auto my-3 text-center">
            {this.state.loadmore ? (
              <FontAwesome
                name="spinner"
                size="2x"
                style={{ color: '#c82590' }}
                spin
              />
            ) : (
              <Button onClick={this.loadmore} outline block color="warning">
                  Load More
              </Button>
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Home;
